import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ImagesCoupons from '../Coupons/ImagesCoupons';
import CategoriesTitle from './CategoriesTitle';
import axios from 'axios';
import Newest from './Newest'
import CategoriesDropDown from './CategoriesDropDown';
import Popularity1 from './Popularity1';
import CategoryCoupons from './CategoryCoupons';

const CategoriesBody = () => {
  const [inputValue, setInputValue] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const [sortOption, setSortOption] = useState('az');
  const [images,setImages]= useState([]);
  const [showNewest,setShowNewest]= useState(false);




  const handleSelect = (value) => {
    setSelectedValue(value);
    setInputValue(value);
    setShowDropdown(false);
  };

  

  useEffect(()=>{
    axios.get('https://api.bakpoket.com/api/Cat_TC_BO/get-Cat_TC_BO?position=Cat')
    .then(res=>setImages(res.data))
    .catch(err=>console.log(err))
  })

  return (
    <Wrapper>
      <div className="container">
        <div className="categories-header">
          <CategoriesTitle className='my-auto'/>
          <CategoriesDropDown />
        </div>

        <div className="filter-table">
          <table>
            <thead>
              <tr>
                <td
                  className={sortOption === 'popularity' ? 'active' : ''}
                  onClick={() => setSortOption('popularity')}
                >
                  Popularity
                </td>
                <td
                  className={sortOption === 'az' ? 'active' : ''}
                  onClick={() => setSortOption('az')}
                >
                  A-Z
                </td>
                <td
                  className={sortOption === 'newest' ? 'active' : ''}
                  onClick={() => setSortOption('newest')}
                >
                  Newest
                </td>
              </tr>
            </thead>
          </table>
        </div>

        {sortOption === 'newest' ? (
          <Newest />
        ) : sortOption === 'popularity' ? (
          <Popularity1 />
        ) : (
          <CategoryCoupons sortBy={sortOption} />
        )}

        {images?.base64 && images?.merchantURL && (
          <a
            href={`https://${images.merchantURL}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="bottom-ad"
              src={`data:image/png;base64,${images.base64}`}
              alt="Categories Ad"
            />
          </a>
        )}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background-color: #f9f9f9;
  border-bottom: 1px solid #ccc;
  padding: 20px 0;

  .container {
    max-width: 1180px;
    margin: 0 auto;
    padding: 0 40px;
  }

  .categories-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    .categories-text {
      font-size: 20px;
      font-weight: bold;
      color: #ef4766;
      // margin-bottom:0px;
    }

    .selectors {
      position: relative;
      width: 240px;

      input {
        padding: 4px 10px 4px 8px;
        font-size: 12px;
        border: 1px solid #ccc;
        border-radius: 4px;
        width: 100%;
      }

      .dropdown {
        position: absolute;
        top: 36px;
        left: 0;
        right: 0;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        max-height: 150px;
        overflow-y: auto;
        list-style: none;
        margin: 0;
        padding: 0;
        z-index: 10;

        li {
          padding: 8px;
          cursor: pointer;
          border-bottom: 1px solid #eee;

          &:hover {
            background-color: #f0f0f0;
          }
        }

        .no-match {
          color: #888;
        }
      }
    }
  }

  .filter-table {
    table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #ccc;

      tr {
        border: 1px solid #ccc;
      }

      td {
        padding: 8px 12px;
        font-weight: 500;
        color: #000;
        cursor: pointer;
        border: 1px solid #ccc;
        text-align: center;
        transition: background-color 0.2s ease;

        &.active {
          background-color: rgb(238, 236, 236);
        }
      }
    }
  }

  .bottom-ad {
    margin: 20px auto 0;
    display: block;
    width: 60%;
  }

  @media (max-width: 768px) {
    .container {
      padding: 0 20px;
    }

    .categories-header {
      flex-direction: row;
      align-items: start;
      gap: 5px;

      .categories-text {
        font-size: 18px;
      }

      .selectors {
        width: 100%;

        input {
          font-size: 12px;
          padding: 6px 8px;
        }
      }
    }

    .bottom-ad {
      width: 90%;
    }
  }

  @media (max-width: 480px) {
    padding: 5px 0;

    .categories-header {
      flex-direction: row;
      align-items: center;
      gap: 5px;
    }
    .categories-header .categories-text {
      font-size: 16px;
    }

    .container {
      padding: 0 10px;
    }

    .filter-table td {
      font-size: 12px;
      padding: 6px;
    }
  }
`;

export default CategoriesBody;
